(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hsn-topic-filter"] && !Shopify.designMode) return;
  try {
    function initializeTopicFilters(scope){
    scope.querySelectorAll('[data-topic-filter]').forEach(function(filter){
      if(filter.dataset.initialized) return;
      filter.dataset.initialized='true';
      var input=filter.querySelector('[data-topic-search]');
      var links=Array.from(filter.querySelectorAll('[data-topic-label]'));
      var empty=filter.querySelector('[data-topic-empty]');
      filter.querySelector('[data-topic-search-label]').hidden=false;
      input.addEventListener('input',function(){
        var term=input.value.trim().toLocaleLowerCase();
        var count=0;
        links.forEach(function(link){
          link.hidden=!link.dataset.topicLabel.toLocaleLowerCase().includes(term);
          if(!link.hidden) count++;
        });
        empty.hidden=count>0;
      });
    });
  }
  initializeTopicFilters(document);
  document.addEventListener('shopify:section:load',function(event){initializeTopicFilters(event.target);});
  } catch(e) { console.error(e); }
})();

})();
